module.exports = __webpack_public_path__ + "img/PS14.9ec50e59.png";